module.exports = __webpack_public_path__ + "static/media/m3.f9517676.png";